<template>
  <div>
    <div v-if="error" class="alert alert-primary bg-primary text-white border-0 show">
      {{$t(error)}}
    </div>
    <b-form>
      <div class="row">
        <div class="col-12">

          <div>
            <a href="#" class="btn btn-outline-danger" @click.prevent="selectFile">
              <span v-if="!dataUrl">Vali XML fail</span>
              <span v-else>Vali uuesti</span>
            </a>
            <span v-show="name"><strong>{{name}}</strong></span>
          </div>

          <b-form-checkbox v-if="error" v-model="overwriteIfExists" class="mt-2">
            Kirjutada üle
          </b-form-checkbox>

          <button id="import-declaration-file" type="button" class="btn btn-primary float-right" @click="submit" :disabled="!dataUrl || loading">
            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Impordi
          </button>

          <input id="declaration-file" ref="fileinput" type="file" accept="*" @change="fileSelected" tabindex=-1 style="display: none">
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'
  import gateway from '@/services/gateway'
  import {utils} from '@/services/Configuration'

  export default {
    components: {ValidatedFormSelect},
    data() {
      return {
        dataUrl: null,
        name: null,
        overwriteIfExists: false,
        error: null,
        loading: false
      }
    },
    methods: {
      selectFile() {
        this.$refs.fileinput.dispatchEvent(new MouseEvent('click'))
      },
      fileSelected(event) {
        const reader = new FileReader()
        const file = event.target.files[0]

        this.name = file.name

        reader.onload = () => {
          this.dataUrl = reader.result
          event.target.value = ''
        }
        reader.readAsDataURL(file)
      },
      submit() {
        const document = {name: this.name, xml: this.dataUrl, overwriteIfExists: this.overwriteIfExists}
        this.loading = true
        gateway.post('/declarations/import', document).then(r => {
          this.$notifications.info('Deklaratsioon on imporditud')
          this.$router.push('/declarations/' + r.data)
          this.$emit('done')
        }).catch(r => this.error = r.response.data.key)
          .finally(() => this.loading = false)
      }
    }
  }
</script>
